import React from 'react';

import { Avatar } from '@mui/material';

const AVATAR_COLORS = ['primary.main', 'secondary.main', 'success.main', 'warning.main', 'info.main', 'error.main'];

interface Props {
  name: string;
  size?: number;
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

// Same name always maps to the same colour so a person's avatar is stable across posts.
function getColor(name: string): string {
  const hash = Array.from(name).reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export default function CaseAvatar({ name, size = 36 }: Props) {
  return (
    <Avatar sx={{ width: size, height: size, fontSize: size / 2.6, bgcolor: getColor(name), color: 'common.white' }}>
      {getInitials(name)}
    </Avatar>
  );
}
